<template>
	<div class='forgot_wrap'>
		<div class="table_container">
			<h1>Reset your password</h1>
			<p class='notice'>We've emailed your 6-digit code to
				<span>{{user_email}}</span>, so please check your inbox. If necessary, please also check your spam and junk folders.<br />If you cannot receive the system e-mail, please contact us by teach@51talk.com</p>
			<p class="wrong" v-show="mis_state">
				<span></span>{{mis_words}}</p>
			<input type="text" v-model.trim='code' placeholder="Code" @blur='check_code' maxlength="6">
			<div class="clearfix btns">
				<a class='continue' @click='next_reset'>Continue</a>
				<a class="cancel" @click='back_login'>Cancel</a>
			</div>
		</div>
	</div>
</template>

<script>
export default {
  data() {
    return {
      user_email: '',
      code: '',
      mis_state: '',
      mis_words: '测试数据'
    }
  },
  methods: {
    next_reset: function() {
      let _this = this
      if (this.mis_state !== false) return
      this.axios
        .get('/index/checkcode', {
          params: {
            email: _this.user_email,
            code: _this.code
          }
        })
        .then(function(response) {
          if (response.data && response.data.code == '75000') {
            window.localStorage.c_c = _this.code

            _this.$router.push('forgot_password_step3')
          } else {
            _this.mis_state = true
            _this.mis_words = response.data.message
          }
        })
    },
    back_login: function() {
      this.$router.go(-1)
    },
    check_code: function() {
      if (!this.code) {
        this.mis_state = true
        this.mis_words = 'Please enter the code you sent.'
      } else {
        this.mis_state = false
      }
    }
  },
  beforeRouteEnter: function(from, to, next) {
    next(vm => {
      vm.user_email = window.localStorage.r_email
    })
  }
}
</script>

<style lang='less' scoped>
.forgot_wrap {
  height: 1000px;
  background: url('~@img/creat_acount_bg.jpg') no-repeat center
    center;
  .table_container {
    position: relative;
    width: 366px;
    margin: 0 auto;
    padding-top: 255px;
    h1 {
      text-align: center;
      color: #ffffff;
      font-size: 38px;
    }
    p {
      font-size: 15px;
      line-height: 20px;
    }
    p.notice {
      margin-top: 44px;
      color: #999999;
      word-break: break-all;
      span {
        color: #febf00;
      }
    }
    p.wrong {
      position: absolute;
      left: 0;
      top: 416px;
      padding-left: 26px;
      margin-top: 5px;
			color: #fe0036;
			white-space: nowrap;
      span {
        position: absolute;
        left: 0;
        top: 0;
        width: 20px;
        height: 19px;
        background: url('~@img/forgot_step_1.png') no-repeat 0 0;
      }
    }
    input {
      background: transparent url('~@img/forgot_step_1.png') no-repeat
        0 -40px;
      box-sizing: border-box;
      padding: 2px 0 13px 33px;
      margin-top: 50px;
      outline: none;
      width: 100%;
      border-bottom: 1px solid #868685;
      color: #fff;
    }
    div.btns {
      padding-top: 47px;
      a {
        float: left;
        cursor: pointer;
        width: 170px;
        height: 46px;
        line-height: 46px;
        font-size: 24px;
        text-align: center;
        border-radius: 50px;
        background: #ffc000;
        color: #000000;
      }
      a.cancel {
        border: 1px solid #ffc000;
        background: transparent;
        color: #ffc000;
        margin-left: 19px;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// forgot_password_step2.vue?0cec4dd9